import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class GrasslandCastleRuinsSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.GRASSLAND_CASTLE_RUINS;
}

export default GrasslandCastleRuinsSalvageableTileEntity;
